import React from "react";
import { Segmented } from "antd";
import { BarsOutlined, AppstoreOutlined } from "@ant-design/icons";
const GeneralSegmented = ({ setLayout, layout }) => {
  const changeLayout = layout => {
    setLayout(layout);
    localStorage.setItem("layout", layout);
  };

  return (
    <Segmented
      size="large"
      value={layout}
      options={[
        {
          value: "list",
          icon: <BarsOutlined size={"large"} />
        },
        {
          value: "grid",
          icon: <AppstoreOutlined size={"large"} />
        }
      ]}
      onChange={changeLayout}
    />
  );
};

export default GeneralSegmented;
